


















































import {
    isMobileLayout,
    useVueRouter,
    useI18n,
} from '@superbet-group/web.lib.vue-utilities';
import {
    defineComponent,
    computed,
    ref,
    onBeforeMount,
} from '@vue/composition-api';

import AboutSuperbet from '@modules/layout/footer/components/AboutSuperbet.vue';
import SponsoredEntities from '@modules/layout/footer/components/SponsoredEntities.vue';
import Help from '@modules/layout/footer/components/Help.vue';
import LegalSection from '@modules/layout/footer/components/LegalSection.vue';
import PaymentLinks from '@modules/layout/footer/components/PaymentLinks.vue';
import PrintableOffer from '@modules/layout/footer/components/PrintableOffer.vue';
import SocialLinks from '@modules/layout/footer/components/SocialLinks.vue';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { getConfig } from '@superbet-group/web.lib.config';
import { Link } from '@src/app/router/constants/Link';
import {
    Country,
    Site,
} from '@superbet-group/web.types';
import { Sponsorship } from '@src/federations/shared/cms/sponsorships/Sponsorship';
import { getSponsorships } from '@src/federations/shared/cms/sponsorships/SponsorshipService';
import { isBrSupersocial } from '@modules/layout/utils/isCountry';
import SuperSocialFooter from '@socialFederation/shared/SuperSocialFooter.vue';
import { useGetFeatureFlag } from '@src/app/shared/featureFlags/useGetFeatureFlag';
import { setPe131DescriptiveOddButtonVariant } from '@app/shared/featureFlags/pe131DescriptiveOddButtonFlag';
import { ExperimentsGroup } from '@superbet-group/product.analytics';
import { AccountFlagNames } from '@modules/userProfile/account/FeatureFlags';
import { currentSite } from '@app/utils/domainHelpers';

export default defineComponent({
    name: 'FooterComponent',
    props: {
        isBeingLoaded: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const { translate } = useI18n();
        const { route } = useVueRouter();
        const isAppsFooterIframe = computed(() => route.value.meta?.isNativeAppsFooter);
        const showFooter = computed(() => {
            return !(route.value.path.startsWith(Link.Account.Container) && isMobileLayout());
        });
        const sponsoredEntities = ref<Sponsorship[]>([]);
        const loadingSponsoredEntities = ref(true);
        const hasSponsoredEntities = ref(false);

        onBeforeMount(async () => {
            try {
                sponsoredEntities.value = await getSponsorships(getConfig().countrySpecific.country);
            } finally {
                loadingSponsoredEntities.value = false;
                hasSponsoredEntities.value = sponsoredEntities.value.length > 0;
            }
        });

        // TODO(brareg): temporary until we have both .com and brareg (non-prod)
        // after we release brareg, everyone can use 'long info' and we can update Lokalise translation
        const longInfoKey = getConfig().countrySpecific.country === Country.Br
            ? 'long info br'
            : 'long info';

        let footerInfoText = '';
        if (currentSite === Site.NapoleonGamesRo) {
            footerInfoText = translate(longInfoKey).replace('Superbet.ro', 'Napoleongames.ro');
        } else {
            footerInfoText = shellLocalConfig.isMexico
                ? 'www.superbet.com operada en Mexico por Producciones Móviles S.A. de C.V., titular del permiso DGAJS/SCEVF/P-06/2005-Ter en unión de Unocapali la Paz Operadora S.A. de C.V. de conformidad con los oficios DGJS/1580/2021 y DGJS/DCRCA/1424/2022. Juegos prohibidos para menores de edad, juegue responsablemente, no olvide que el principal propósito es la recreación, diversión y esparcimiento.Debes tener más de 18 años para jugar. El juego puede ser adictivo. Juega de manera responsible.'
                : translate(longInfoKey);
        }

        // These FF reading is made here because this is the only Composition API component
        // that exists in all screens affected by the experiment.
        const [
            _,
            onPe131VariantReady,
        ] = useGetFeatureFlag<ExperimentsGroup>(AccountFlagNames.pe131DescriptiveOddName, ExperimentsGroup.None);
        onPe131VariantReady((flagValue) => {
            setPe131DescriptiveOddButtonVariant(flagValue);
        });

        return {
            isAppsFooterIframe,
            showPrintableOffer: computed(() => (getConfig().sportsOffer?.isRetailFrontendEnabled && !isAppsFooterIframe.value)),
            showFooter,
            sponsoredEntities,
            loadingSponsoredEntities,
            hasSponsoredEntities,
            footerInfoText,
            isMexico: shellLocalConfig.isMexico,
            isBrSupersocial,
        };
    },
    components: {
        SuperSocialFooter,
        PrintableOffer,
        PaymentLinks,
        Help,
        LegalSection,
        SocialLinks,
        AboutSuperbet,
        SponsoredEntities,
    },
});
